import firebase from "firebase/app";
import "firebase/firestore";
import { createContext, PropsWithChildren, useEffect, useState } from "react";
import { Store } from "../interfaces/IStore";

declare global {
  interface Window {
    singleStore?: boolean;
    targetStore?: string;
    competitor?: {
      locationName?: string;
      coords?: {
        lat?: number | string;
        lng: number | string;
      };
      avgRatings: number;
      placeId: string | number;
      business_type: string;
    }[];
    data?: {
      [key: string]: any;
    };
  }
}
interface ICoords {
  lat: number;
  lng: number;
}

interface IMapContext {
  allStores: Store[];
  stores: Store[];
  setStores: (stores: Store[]) => void;
  currentStore: Store | undefined;
  setCurrentStore: (currentStore: Store | undefined) => void;
  coords: ICoords;
  setCoords: (coords: ICoords) => void;
  sortCoords: ICoords;
  setSortCoords: (coords: ICoords) => void;
  defaultZoom: number;
  setDefaultZoom: (zoom: number) => void;
}

export const MapContext = createContext<IMapContext>({
  allStores: [],
  stores: [],
  setStores: (stores: Store[]) => {},
  currentStore: undefined,
  setCurrentStore: (currentStore: Store | undefined) => {},
  coords: {
    lat: 45.5017,
    lng: -73.5673,
  },
  setCoords: (coords: ICoords) => {},
  sortCoords: {
    lat: 45.5017,
    lng: -73.5673,
  },
  setSortCoords: (coords: ICoords) => {},
  defaultZoom: 15,
  setDefaultZoom: (zoom: number) => {},
});

const apiKey = "AIzaSyDu38iTBz3xKFM8-xnluvYvzuPNFR6fylc";
const firebaseConfig = {
  apiKey: "AIzaSyAR95ky2S_jfC0d7vFSElf5HDsp7ENrVqM",
  authDomain: "polysleep-5290e.firebaseapp.com",
  databaseURL: "https://polysleep-5290e.firebaseio.com",
  projectId: "polysleep-5290e",
  storageBucket: "polysleep-5290e.appspot.com",
  messagingSenderId: "130018477929",
  appId: "1:130018477929:web:fc91f1a29b1ff1743f1ff8",
};

if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);

export const MapProvider = (props: PropsWithChildren<any>) => {
  const [allStores, setAllStores] = useState<Store[]>([]);
  const [stores, setStores] = useState<Store[]>([]);
  const [coords, setCoords] = useState({
    lat: 45.5017,
    lng: -73.5673,
  });

  const [sortCoords, setSortCoords] = useState(coords);
  const [currentStore, setCurrentStore] = useState<Store>();
  const [defaultZoom, setDefaultZoom] = useState<number>(15);
  const { children } = props;
  useEffect(() => {
    let unsubscribe: () => void;
    firebase
      .firestore()
      .collection("stores")
      .onSnapshot((snap) => {
        const stores: any[] = [];
        snap.docs.forEach((doc) => stores.push(doc.data() as any));
        if (window?.competitor) {
          setAllStores([
            ...stores,
            ...window.competitor
          ])
        } else if (window?.targetStore) {
          const targetStore = stores.find(
            (store) => store.id === window.targetStore
          );
          setAllStores(stores);
          setCurrentStore(targetStore);
        } else {
          setAllStores(stores);
        }
      });
    return () => {
      unsubscribe && unsubscribe();
    };
  }, []);

  useEffect(() => {
    currentStore &&
      setCoords({ lat: currentStore?.latitude, lng: currentStore?.longitude });
  }, [currentStore]);

  useEffect(() => {
    setStores(allStores);
  }, [allStores]);
  return (
    <MapContext.Provider
      value={{
        allStores,
        stores,
        setStores,
        currentStore,
        setCurrentStore,
        coords,
        setCoords,
        sortCoords,
        setSortCoords,
        defaultZoom,
        setDefaultZoom,
      }}>
      {children}
    </MapContext.Provider>
  );
};
